export const BANNER_LIST_CACHE = 'CACHE.KEY.BANNER.LIST'
